import React, { useState, useEffect } from 'react';
import CardTemplate from './CardTemplate';

function WhatsApp(props) {
    
    const { message, click, isSelected, isName = false, isError, isLoader = false} = props;
    const {
        body,
        footer,
        mediaurl,
        buttontext,
        name,
        mediatext = "",
        cards,
        createdAt,
        audiourl,
        document,
        id
        } = message;

    const onclick = () =>{
       if(click){
        click(message);
       } 
    }

    const format_text =(text) => {
        if(text === null || text === undefined) return "";
        let format_text = text.replaceAll(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
             .replaceAll(/(?:_)([^_<\n]+)(?:_)/g, "<i>$1</i>")
              .replaceAll(/(?:\~)([^~<\n]+)(?:\~)/g, "<s>$1</s>")
              .replaceAll(/(?:```)([^```<\n]+)(?:```)/g, "<tt>$1</tt>")
              .replaceAll(/\r?\n/g, "<br>");
        if(isError){
            let form = [/<br><br><br>/g, /<\/i><i>/g, /<\/s><s>/g, /<\/tt><tt>/g, /<\/strong><strong>/g];
            let cou =[0,0,0,0,0];
            let men = null;
            for (let index = 0; index < form.length; index++) {
                const element = form[index];
                var count = (format_text.match(element) || []).length;
                if(count > cou[index]){
                    men = "error_whastsapp_"+(index+1);
                }
            }
            isError(men);
        }

        return format_text;

    }
    let cardsWA = cards;
    if(cardsWA && !Array.isArray(cardsWA)){
        cardsWA = JSON.parse(cardsWA);
    }
    return (
        <>
            <div className={`wp ${isSelected ? 'active' : ''}`} onClick={() => onclick()} id={id}>
                {!isLoader ? (
                    <>
                        {isName ? (<div className='name'>{name}</div>) : null}
                        {!cards ? (
                            <>
                            {mediatext === "" ? (
                                <div className='img'>{mediaurl && mediaurl !== "" ? 
                                (mediaurl.includes(".mp4") ? <video controls>
                                <source src={mediaurl} type="video/mp4"></source></video> : <img src={mediaurl}/>) 
                                : <div className='img-black'></div>}</div>
                            ) : (<div className='headerText'>{mediatext}</div>)}
                            </> 
                        ) : null}
                        {audiourl ? (<div className='audio'><audio controls><source src={audiourl} type="audio/mpeg"></source></audio></div>) : null}
                        {document ? (
                        <div className="document">
                            <div className="document-icon">
                            {document.icon}
                            </div>

                            <div className="document-content">
                            <div className="document-name">
                                {document.name}
                            </div>

                            <div className="document-type">
                                {document.type}
                            </div>

                            <a
                                href={document.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="document-action"
                            >
                                Ver archivo
                            </a>
                            </div>
                        </div>
                        ) : null}

                        {body ? (<div className='body' dangerouslySetInnerHTML={{__html: format_text(body)}} />) : null}
                        {!cards ? (
                        <>
                            <div className='footer'>{footer}</div>
                            {buttontext === "" || buttontext === undefined ? null : (
                                <div className='button-wp'><img src="/img/linkwp.png" />{buttontext}</div>    
                            )}
                        </>
                        ) : null}
                        {createdAt ? <div className='date'>{createdAt}</div> : null}
                </> ) : (
                  
                    <div role="status" style={{padding: "1rem"}} class="max-w-sm p-4 border border-gray-200 rounded-sm shadow-sm animate-pulse md:p-6 dark:border-gray-700">
                        <div class="flex items-center justify-center h-48 mb-4 bg-gray-300 rounded-sm dark:bg-gray-700">
                            <svg class="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"/>
                                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
                            </svg>
                        </div>
                        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                        <span class="sr-only">Loading...</span>
                    </div>
                )}
            </div>
            {cardsWA && Array.isArray(cardsWA) ? (
                <div className='create-wa-cards'>
                    { cardsWA.map((item, key) => (
                        <div className={`wp ${isSelected ? 'active' : ''}`} onClick={() => onclick()}>
                            <div className='img'>{item.media !== "" ? 
                            (item.media.includes(".mp4") ? <video controls>
                            <source src={item.media} type="video/mp4"></source></video> : <img src={item.media}/>) 
                            : <div className='img-black'></div>}</div>
                            <div className='headerText'>{item.title}</div>
                            <div className='body' dangerouslySetInnerHTML={{__html: format_text(item.body)}} />
                            {item.actions[0].title === "" ? null : (
                                <div className='button-wp'><img src="/img/link.png" />{item.actions[0].title}</div>
                            )}
                       </div>
                       
                    ))}
                </div>
            ) : null}
        </>
    );
}
    
export default WhatsApp;
